import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as jobActions from '../../../actions/jobActions';
import JobViewPage from './JobViewPage';

class JobViewPageContainer extends React.Component {
    constructor(props) {
        super(props);

        // set id from url
        this.jobId = props.match.params.id;
        this.props.actions.getJob(this.jobId);
    }

    getFormatedJob() {
        let {
            job,
            user,
        } = this.props;

        let logoUrl = null;
        if (user.company.image) {
            logoUrl = user.company.image.path;
        }

        return Object.assign({}, job, {
            companyName: user.company.name,
            logoUrl: logoUrl,
        });
    }

    render() {
        if (!this.jobId || !this.props.job.title) {
            return null;
        }

        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card m-b-20">
                            <div className="card-block">
                                <JobViewPage
                                    job={this.getFormatedJob()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        job: state.job,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                jobActions,
            ), dispatch
        )
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(JobViewPageContainer);


// WEBPACK FOOTER //
// ./web/src/components/jobs/view/JobViewPageContainer.jsx